import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { MakePrivateDocumentDialog } from "../../-components/make-private-document-dialog"

export const Route = createFileRoute(
  "/_layout/documents/_list/make-private/$documentId",
)({
  component: MakePrivateDocumentModal,
})

function MakePrivateDocumentModal(): React.ReactElement {
  const { documentId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <MakePrivateDocumentDialog
      documentId={documentId}
      onClose={() => navigate({ to: "/documents", search: true })}
    />
  )
}
